import React from "react";
import { useTranslation } from "react-i18next";
import ExpertisePageTemplate from "../components/ExpertisePageTemplate";

export default function IntegrateAiPage() {
  const { t } = useTranslation();
  const data = t("pillarPages.integrateAi", { returnObjects: true });

  return (
    <ExpertisePageTemplate
      pageKey="integrate-ai"
      data={data}
      mediaSlotLabel={t("aboutPage.media.slot")}
      primaryHref="/contact"
    />
  );
}
